<main id="main">
  <section
    class="section__hero d-flex flex-column justify-content-between justify-content-sm-center"
  >
    <div class="container">
      <div class="hero__caption text-white">
        <div class="p-3">
          <h1 class="text-secondary">Open Maps for Europe</h1>
          <p>
            Providing easy access to pan-European open data created using official map, geospatial
            and land information.
          </p>
        </div>
        <div class="d-flex justify-content-end">
          <a routerLink="/access-data" class="btn btn-secondary d-flex align-content-center">
            Access Data
            <i class="bi bi-cloud-arrow-down ms-1"></i>
          </a>
          <a
            routerLink="/explore-map/egm-erm-basemap"
            class="btn btn-secondary d-flex align-content-center ms-2"
          >
            Explore Map
            <i class="bi bi-globe ms-1"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center d-sm-none">
      <button
        class="btn btn-lg text-white datasets__link"
        href="#datasets"
        (click)="scrollToDatasets()"
      >
        <span class="sr-only">View datasets section</span>
        <i class="bi bi-chevron-down"></i>
      </button>
    </div>
  </section>
  <section class="dataset__slider py-4" id="datasetsSlider">
    <div class="container">
      <h2 class="mb-4">Datasets</h2>
      <div class="list__wrapper">
        <ul class="list-unstyled d-flex" *ngIf="!loading; else loader">
          <li *ngFor="let dataset of datasets" class="card ms-3 shadow">
            <img
              src="../../assets/els/images/datasets/landscape/{{ dataset.mapServiceURLSlug }}.jpg"
              srcset="
                ../../assets/els/images/datasets/landscape/{{dataset.mapServiceURLSlug}}@2x.jpg 2x
              "
              class="card-img-top"
              alt="{{ dataset.name }}"
            />
            <div class="card-body">
              <h3 class="card-title" [innerHTML]="dataset.name"></h3>
              <p class="card-text" [innerHTML]="dataset.mapServiceDescription"></p>
            </div>
            <div class="card-footer bg-white d-flex justify-content-end p-0 border-0">
              <a class="btn btn-secondary" routerLink="/datasets/{{ dataset.mapServiceURLSlug }}"
                >More Info
                <span class="sr-only">about {{ dataset.name }} Dataset</span>
                <i class="bi bi-info-circle"></i>
              </a>
              <a class="btn btn-secondary" routerLink="/explore-map/{{ dataset.mapServiceURLSlug }}"
                >View <span class="sr-only">{{ dataset.name }} Dataset </span>on Map
                <i class="bi bi-globe"></i>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
  <section class="container my-3 my-lg-5">
    <div class="row">
      <div class="col-12 col-sm-6">
        <p>
          Open Maps for Europe provides free to use open data created using official map, geospatial and land
          information from official, national sources. The Open Maps for Europe online service is developed by
          <a href="https://idoxgeospatial.co.uk" target="_blank">Idox Geospatial</a>, and enables users to discover, view, license and download the open datasets.
        </p>
        <p>
          The Open Maps for Europe project, which was completed in December 2022, was co-financed by the Connecting
          Europe Facility of the European Union.
        </p>
        <p>
          Open Maps for Europe 2 (OME2) builds on its success by providing a foundation for future pan-European
          high-value datasets. It is developing a new production process and technical specification for free-to-use,
          edge-matched, interoperable data under a single open licence to create a prototype dataset covering 10
          countries. The prototype is aligned to key EU Policy objectives and UN core geospatial data recommendations.
        </p>
      </div>
      <div class="col-12 col-sm-6">
        <p>
          The project, which is co-funded by the European Union through DIGITAL Europe, is being delivered by a
          consortium comprising: EuroGeographics; National Geographic Institute, Belgium; National Institute of
          Geographic and Forest Information, France; Hellenic Cadastre; General Directorate for the Cadastre, Spain; and
          Cadastre, Land Registry and Mapping Agency, The Netherlands.
          <span class="d-block mt-2">
            For more information, please visit
            <a
              href="https://eurogeographics.org/open-maps-for-europe/ome2-progress/"
              target="_blank"
              class="btn-link"
            >
              https://eurogeographics.org/open-maps-for-europe/ome2-progress/
            </a>
          </span>
        </p>
        <p>
          Views and opinions expressed are those of the author only and do not necessarily reflect those of the European
          Union or European Commission. Neither the European Union nor the European Commission can be held responsible
          for them.
        </p>
        <p>
          <a
            href="https://eurogeographics.us1.list-manage.com/subscribe?u=5c0e0618f3242180bd70b3dd5&id=31bcc5abef"
            target="_blank"
            class="btn btn-secondary"
          >Sign up for our newsletter<i class="bi bi-box-arrow-up-right ms-2"></i
          ></a>
        </p>
        <img
          src="../../../assets/els/images/logos/ome-2-logo-next-to-eu-logo.png"
          class="img-fluid img-size mt-3"
          alt="OME2, co-funded by the European Union"
        />
      </div>
    </div>
  </section>
</main>
<app-footer showBackToTop="true" target="header"></app-footer>

<ng-template #loader>
  <section class="container py-5">
    <div class="alert alert-primary d-flex align-items-center justify-content-center" role="alert">
      <div class="spinner-border me-3" role="status"></div>
      Loading...
    </div>
  </section>
</ng-template>
